// src/components/Widget.js
import React from 'react';
import styled from 'styled-components';

const WidgetContainer = styled.div`
  background-color: ${({ $bgColor }) => $bgColor || '#ffffff'};  /* Default to white if no bgColor is passed */
  padding: 20px;
  color: white;
  width: 200px;
  border-radius: 10px;
  margin: 10px;
  box-shadow: ${({ theme }) => theme === 'dark' ? '0 8px 20px rgba(0, 0, 0, 0.3)' : '0 8px 20px rgba(0, 0, 0, 0.15)'};
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: ${({ theme }) => theme === 'dark' ? '0 12px 25px rgba(0, 0, 0, 0.5)' : '0 12px 25px rgba(0, 0, 0, 0.2)'};
  }
  
  @media (max-width: 768px) {
    width: 120px;
    padding: 10px;
  }
`;

const WidgetTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 8px;
  font-weight: bold;
  color: ${({ theme }) => (theme === 'dark' ? '#ecf0f1' : '#e0efff')};
`;

const WidgetValue = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => (theme === 'dark' ? '#f39c12' : '#e0efff')};
  font-weight: 600;
`;

const Widget = ({ title, value, bgColor }) => (
  <WidgetContainer $bgColor={bgColor}>
    <WidgetTitle>{title}</WidgetTitle>
    <WidgetValue>{value}</WidgetValue>
  </WidgetContainer>
);

export default Widget;
